import { useState, useEffect } from "react";
import BTC from "../../../assets/images/BTCPic.png";
import Currency from "../../../services/Currency";

export default function Symbols({ isOpen, onClose, onSelect }) {
    const [currencies, setCurrencies] = useState([]);
    const [filter, setFilter] = useState("");
    const [finalFilter, setFinalFilter] = useState("");

    async function getCurrencies() {
        try {
            const params = {
                search: finalFilter || "",
            };

            const res = await Currency.getAll(params);
            setCurrencies(res?.data?.data || []);
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        getCurrencies();
    }, [finalFilter]);

    if (!isOpen) return null;

    return (
        <>
            {/* Backdrop */}
            <div
                onClick={onClose}
                className="fixed inset-0 z-40 bg-black/20 backdrop-blur-sm"
            />

            {/* Bottom Sheet */}
            <div className="fixed bottom-0 left-0 right-0 z-50 h-[55vh] rounded-t-[41px] bg-gray-50 backdrop-blur-xl shadow-[0px_4px_22.4px_0px_#00000040] flex flex-col">

                {/* Handle */}
                <div className="flex justify-center py-3">
                    <div className="w-14 h-1.5 rounded-full bg-gray-300" />
                </div>

                {/* Content */}
                <div className="flex-1 min-h-0 px-6 pb-6 flex flex-col">

                    {/* Search */}
                    <div className="relative mb-4 flex-shrink-0">
                        <input
                            value={filter}
                            onChange={(e) => setFilter(e.target.value)}
                            className="w-full h-11 rounded-full bg-[#E8E8E8] pr-[28%] pl-5 outline-none"
                            placeholder="Search currency..."
                        />

                        <button
                            onClick={() => setFinalFilter(filter)}
                            className="absolute right-0 top-0 h-full w-1/4 rounded-full bg-[#7B8FEB] text-white"
                        >
                            Search
                        </button>
                    </div>

                    {/* Scrollable List */}
                    <div className="flex-1 min-h-0 overflow-y-auto divide-y divide-gray-200">
                        {currencies.map((it) => (
                            <button
                                key={it._id}
                                onClick={() => onSelect(it)}
                                className="flex w-full items-center gap-3 py-3 text-left hover:bg-gray-100 transition"
                            >
                                <img
                                    src={
                                        it?.image?.path
                                            ? `https://api.7-trade.ir/${it.image.path}`
                                            : BTC
                                    }
                                    alt={it?.symbol}
                                    className="w-8 h-8 rounded-full object-cover flex-shrink-0"
                                />

                                <p className="text-gray-600 text-base">
                                    {it?.name} ({it?.symbol})
                                </p>
                            </button>
                        ))}

                        {currencies.length === 0 && (
                            <div className="py-10 text-center text-gray-500">
                                No currencies found
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}